import { SxProps } from "@mui/material"

export const accordionStyles: SxProps = {
  position: "relative",
  borderRadius: "12px",
  marginBottom: "1.75rem",
  "&.Mui-expanded": {
    margin: 0,
    marginBottom: "inherit",
  },
  "& .MuiAccordionSummary-root": {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    padding: "1.5rem 2.5rem 1.5rem",
    minHeight: 0,
    ".MuiAccordionSummary-content": {
      padding: 0,
      margin: 0,
    },
  },
  "& .MuiAccordionDetails-root": {
    position: "relative",

    padding: "2.5rem 2.5rem 4rem 2.5rem",
  },
}
